<template>
  <CustomDialog
    :visible="visible"
    @update:visible="updateVisible"
    :modalClass="
      ['w-[900px]', 'border-l-icon-tertiary! ', 'border-l-2!', modalClass].join(
        ' ',
      )
    "
    :closable="closable"
  >
    <!-- Encabezado -->
    <template #header>
      <div class="inline-flex items-center justify-center gap-2">
        <font-awesome-icon
          id="test-custom-icon"
          :icon="icon"
          class="text-[24px] leading-6 text-center text-icon-tertiary font-normal"
        />
        <span
          id="test-header"
          class="ml-2 font-semibold whitespace-nowrap text-[20px] leading-6 tracking-[-0.2px] dark:text-dark-secondary"
        >
          {{ header }}
        </span>
      </div>
    </template>

    <!-- Descripción -->
    <template #description>
      <span
        id="test-description"
        class="test-description text-text-secondary font-normal text-[14px] leading-5 tracking-[-0.4px] dark:text-dark-secondary mt-1 block text-center"
      >
        {{ description }}
      </span>
    </template>

    <!-- Botones -->
    <template #footer>
      <div class="flex justify-center gap-2">
        <CustomButton
          id="test-cancel"
          label="Cancelar"
          variant="primary_outlined"
          buttonClass="text-text-primary! hover:bg-text-primary-hover! hover:text-white! 
          text-[12px]! font-bold leading-[16px]! tracking-[0.2px]"
          @click="cancel"
        />
        <CustomButton
          id="test-delete"
          class="w-24.75 h-10"
          buttonClass="text-[12px]! font-bold leading-[16px]! tracking-[0.2px]"
          label="Sí, Eliminar"
          @click="handleContinue"
        />
      </div>
    </template>
  </CustomDialog>
</template>

<script setup lang="ts">
import CustomButton from "./CustomButton.vue";

const props = defineProps({
  visible: Boolean,
  closable: Boolean,
  header: String,
  description: String,
  modalClass: String,
  icon: {
    type: String,
    default: "fa-regular fa-trash-can",
  },
});
const emit = defineEmits(["update:visible", "handleContinue", "handleDelete"]);
const updateVisible = (value: boolean) => {
  emit("update:visible", value);
};
const cancel = () => {
  updateVisible(false);
};
const handleContinue = () => {
  emit("handleDelete");
};
</script>
